import { styled } from '@material-ui/core';

export const AlignRight = styled('div')(props => ({
  textAlign: 'right',
}));
